// extracted by mini-css-extract-plugin
export default {"swiper":"CarouselBanners_swiper__jwgGy","swiperSlide":"CarouselBanners_swiperSlide__0b8fq"};